import type { KeyboardEvent } from 'react';

/** Keep boundary Tab presses in the open dialog; Bootstrap handles Escape/restoration. */
export function containModalFocus(event: KeyboardEvent<HTMLElement>) {
  if (event.key !== 'Tab' || event.defaultPrevented) return;
  // React-Bootstrap forwards this handler to the inner .modal-dialog element.
  const dialog = event.currentTarget.closest<HTMLElement>('[role="dialog"]') || event.currentTarget;
  // Leave any nested dialog to its own focus handling.
  if ((event.target as Element).closest('[role="dialog"]') !== dialog) return;
  const controls = Array.from(dialog.querySelectorAll<HTMLElement>(
    'button, a[href], input, select, textarea, [contenteditable="true"], [tabindex]',
  )).filter(element => {
    if (element.tabIndex < 0 || element.matches(':disabled') || element.closest('[hidden], [aria-hidden="true"]')) return false;
    for (let node: HTMLElement | null = element; node && node !== dialog; node = node.parentElement) {
      const style = getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
    }
    return true;
  });
  const first = controls[0];
  const last = controls[controls.length - 1];
  if (!first) {
    event.preventDefault(); dialog.focus();
  } else if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
    event.preventDefault(); last.focus();
  } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === dialog)) {
    event.preventDefault(); first.focus();
  }
}
